import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=468b9236"
import script from "./InputForm.vue?vue&type=script&lang=ts"
export * from "./InputForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports